<div class="swedish-container" id="swedish-container" cdkDropList
     (cdkDropListEntered)="dropZoneWord = undefined">
  <lib-puzzle-crossword-sidebar #sidebar *ngIf="showDefinList" class="swedish-definition-list puzzle-elevation-z2"
                                [crosswordBoardConfig]="finalCrosswordBoardConfig" [availableHeight]="availableHeight">
  </lib-puzzle-crossword-sidebar>
  <div class="swedish-board" id="swedish-board" #zoomBoard>
    <div class="swedish-zoom"
         libAppPuzzleZoom [availableHeight]="availableHeight"
         (mousedown)="onMouseDown($event)"
         [style.width.px]="boardWidthPx" [style.height.px]="boardHeightPx"
         [boardWidth]="boardWidthPx" [boardHeight]="boardHeightPx">
      <div class="swedish-tiles"
           [style.width.px]="boardWidthPx" [style.height.px]="boardHeightPx">
        <div *ngFor="let tile of tiles" class="swedish-tile"
             [class.is-saying]="tile.sayingIndex"
             [class.is-definition]="tile.type === CrosswordTilesEnum.DefinitionField"
             [class.is-definition-block]="tile.type === CrosswordTilesEnum.DefinitionField && crosswordBoardConfig.configPreset === '221'"
             [class.is-hidden] = "tile.isHidden"
             [class.is-divider] = "tile.isDivider"
             [class.selected-tile]="!dropZoneWord && !bottomWordFocus && tile === currentTile"
             [class.selected-word]="!dropZoneWord && !bottomWordFocus && tile.wordList.indexOf(currentWord) !== -1"
             [class.selected-solution]="bottomWordFocus && tile === currentTile"
             [class.highlight-animate]="tile.highlightAnimate || highlightAnimateGlobal"
             [class.highlight-correct]="tile.highlightCorrect"
             [class.drop-zone-active]="dropZoneWord && dropZoneWord.tiles.indexOf(tile) !== -1"
             [class.border-top]="tile.borders && tile.borders.top"
             [class.border-right]="tile.borders && tile.borders.right"
             [class.border-bottom]="tile.borders && tile.borders.bottom"
             [class.border-left]="tile.borders && tile.borders.left"
             [class.highlight-wrong]="tile.highlightWrong"
             cdkDropList
             [id]="'crossword-tile-' + tile.index"
             (cdkDropListDropped)="onDropListDropped($event, tile)"
             (cdkDropListEntered)="cdkDropListEntered($event, tile)"
             (cdkDropListExited)="cdkDropListExited()">
          <div *ngIf="tile.type === CrosswordTilesEnum.DefinitionField">
            <lib-app-definition-tile class="definition-inner"
                                     (definitionClicked)="onDefinitionTileClicked($event)"
                                     *ngIf="finalCrosswordBoardConfig.definFields === 'show'"
                                     [crosswordBoardConfig]="finalCrosswordBoardConfig"
                                     [tile]="tile"
                                     [wordSelected]="!dropZoneWord && !bottomWordFocus && tile.wordList.indexOf(currentWord) !== -1"
            >
            </lib-app-definition-tile>
          </div>

          <div class="solution-index" *ngIf="tile.solutionIndex">{{ tile.solutionIndex }}</div>

          <div class="horizontal-number" (click)="onDefinitionTileClicked(tile.words.horizontal)" *ngIf="crosswordBoardConfig.showWordLengths !== 'no' && tile.horizontalNumber"><p>{{tile.horizontalNumber}}</p></div>
          <div class="vertical-number" (click)="onDefinitionTileClicked(tile.words.vertical)" *ngIf="crosswordBoardConfig.showWordLengths !== 'no' && tile.verticalNumber"><p>{{tile.verticalNumber}}</p></div>

          <div class="swedish-input-tile animate-opacity" *ngIf="tile.type === CrosswordTilesEnum.InputField"
               [class.preset]="tile.preset"
               [class.hide-field]="hideFields[tile.index]"
               [class.show-solution]="showSolution[tile.index]"
               [style.--opacity-animation-time.ms]="opacityAnimationTime"
               (click)="onInputTileClicked(tile, false, $event)">
            {{showSolution[tile.index] ? tile.letter : swedishGame && swedishGame.userInput[tile.index]}}
          </div>
          <div class="word-index" *ngIf="showWordIndices && tile.fieldNumber">{{tile.fieldNumber}}</div>
          <div class="divider divide-right" *ngIf="tile.divideRight"></div>
          <div class="divider divide-bottom" *ngIf="tile.divideBottom"></div>
          <div class="copyright" *ngIf="tile.index === tiles.length - 1 && framework.puzzleFrameworkConfig.showCopyright"><a href="http://krupion.de">&copy;krupion.de</a></div>
        </div>
      </div>
      <div class="swedish-puzzle-ad" *ngFor="let puzzleAd of puzzleAds"
           [style.width.px]="puzzleAd.width" [style.height.px]="puzzleAd.height"
           [style.top.px]="puzzleAd.top" [style.left.px]="puzzleAd.left"
           (click)="puzzleAdClicked(puzzleAd.link)" (mousedown)="puzzleAdMouseDown($event)">
        <img [ngClass]="{'puzzle-ad-link': puzzleAd.link}" class="puzzle-ad-image"
             src="{{puzzleAd.imageUrl}}">
      </div>
    </div>
  </div>
</div>

<div *ngIf="bottomWordTiles.length" #footer>
  <ion-toolbar class="swedish-bottom-bar puzzle-elevation-z3" [class.remove-side-margins]="removeSideMargins">
    <div class="swedish-solution-word" #bottomWord [ngClass]="{'scroll': bottomWordScroll}" [class.is-saying]="bottomWordIsSolutionWord===false"
         (mousedown)="onBottomWordMouseDown($event)"
         (mousewheel)="onBottomWordMouseWheel($event)"
         (touchmove)="onBottomWordTouchMove($event)"
         (touchstart)="onBottomWordTouchStart($event)"
         (touchend)="onBottomWordTouchEnd($event)"
         (touchcancel)="onBottomWordTouchEnd($event)">
      <div class="solution-tiles" [style.transform]="'scale(' + solutionZoomValue + ')'">
        <div *ngFor="let tile of bottomWordTiles"
             (click)="onBottomWordTileClicked(tile, $event)"
             [class.swedish-tile]="tile.type !== CrosswordTilesEnum.OriginalSolution"
             [class.original-tile]="tile.type === CrosswordTilesEnum.OriginalSolution"
             [class.selected-tile]="bottomWordFocus && tile === currentTile"
             [class.selected-word]="bottomWordFocus || tile === currentTile">

          <div *ngIf="tile.type !== CrosswordTilesEnum.OriginalSolution" class="solution-index">{{ tile.solutionIndex }}</div>
          <div *ngIf="tile.type !== CrosswordTilesEnum.OriginalSolution" class="swedish-input-tile">{{swedishGame && swedishGame.userInput[tile.index]}}</div>
          <div *ngIf="tile.type === CrosswordTilesEnum.OriginalSolution" class="original-solution-letter">{{ tile.letter }}</div>

        </div>
      </div>
    </div>
    <!--<lib-app-puzzle-sweepstake-button class="solution-sweepstake-button"-->
    <!--                                  *ngIf="displaySweepstakeButton && !noSpaceForSweepstakeButton">-->
    <!--</lib-app-puzzle-sweepstake-button>-->
  </ion-toolbar>
</div>

<lib-puzzle-softkeyboard class="puzzle-elevation-z2"></lib-puzzle-softkeyboard>
